import script from "./ingredients-invalid-dv-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ingredients-invalid-dv-dialog.vue?vue&type=script&setup=true&lang=js"

import "./ingredients-invalid-dv-dialog.vue?vue&type=style&index=0&id=60fd6c8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60fd6c8e"]])

export default __exports__